import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.8 3a1.5 1.5 0 0 0-1.5-1.5h-14A1.5 1.5 0 0 0 6.8 3v8a1.5 1.5 0 0 0 1.5 1.5h14a1.5 1.5 0 0 0 1.5-1.5Zm-2 7.25a.25.25 0 0 1-.25.25H9.05a.25.25 0 0 1-.25-.25V3.78a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.3 7.03a2 2 0 1 0 4 0a2 2 0 1 0-4 0m6.9 9.5l-3.53 1.17a.23.23 0 0 0-.15.14A2 2 0 0 1 14.7 19h-4a.5.5 0 0 1-.5-.5a.5.5 0 0 1 .5-.5h4a1 1 0 0 0 0-2h-3.5a7.15 7.15 0 0 0-4-1.5H5.14a4 4 0 0 0-1.79.5l-3 1.51a.25.25 0 0 0-.13.22v5.4a.26.26 0 0 0 .13.22a.25.25 0 0 0 .25 0l3.22-2a1 1 0 0 1 .85-.1c10 3.36 6.63 3.37 17.87-2.31a.52.52 0 0 0 .06-.94a2.48 2.48 0 0 0-2.4-.47"
    }, null, -1)
  ]))]))
}
export default { render: render }